import { selector } from 'recoil';
import { type CoverageTextItemRequest, type CoverageTextItem } from '../types/hippoTypes';
import { loadCoverages } from '../../services/hippo.service';
import { topConfigContextAtom } from '../atoms/topConfigContextAtom';
import { getExistingCoveragesSelector } from './getExistingCoveragesSelector';
import { type CoverageOpcDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/opc';

const getCoverageRequestItems = (
    coverages: CoverageOpcDTO[] | undefined
): CoverageTextItemRequest[] => {
    if (coverages) {
        return coverages.map((coverage) => ({
            termsId: coverage.flavourTermId ?? '',
            coverageId: coverage.type ?? ''
        }));
    }
    return [];
};

export const coverageTermsSelector = selector<CoverageTextItem[]>({
    key: 'coverageTermsSelector',
    get: async ({ get }) => {
        const topConfigContext = get(topConfigContextAtom);
        const existingCoverages = get(getExistingCoveragesSelector);
        const requestList = getCoverageRequestItems(existingCoverages);

        return await loadCoverages(topConfigContext, requestList);
    }
});
